module.exports = __webpack_public_path__ + "1bfad5c25b4c297b1a2c59040b719b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/search-results/images/Dropdown.png
// module id = 782
// module chunks = 0